import React from "react";
import { EDGE } from "./primitives";
import { footer as F } from "../mock/inferraData";

export default function Footer() {
  return (
    <footer
      style={{
        background: "#14201b",
        color: "#a3ada6",
        paddingLeft: EDGE,
        paddingRight: EDGE,
        paddingTop: 64,
        paddingBottom: 64,
      }}
    >
      <div
        className="ft-inner"
        style={{ maxWidth: 1440, margin: "0 auto", width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 60 }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12, width: 360, maxWidth: "100%" }}>
          <span className="font-type" style={{ fontSize: 24, fontWeight: 700, letterSpacing: "-0.6px", color: "#ece7dc" }}>{F.brand}</span>
          <span style={{ fontSize: 14, lineHeight: 1.55 }}>{F.blurb}</span>
          <span style={{ fontSize: 13, color: "#6d7973", marginTop: 4 }}>{F.copyright}</span>
        </div>
        <div className="ft-groups" style={{ display: "flex", gap: 84 }}>
          {F.groups.map((g) => (
            <div key={g.title} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <span style={{ fontWeight: 600, color: "#ece7dc", fontSize: 14 }}>{g.title}</span>
              {g.links.map((l) => (
                <a key={l} href="#top" className="hover-x" style={{ fontSize: 14, color: "#a3ada6" }}>{l}</a>
              ))}
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 820px) {
          .ft-inner { flex-direction: column; gap: 40px; }
          .ft-groups { gap: 48px; flex-wrap: wrap; }
        }
      `}</style>
    </footer>
  );
}
